import suppressErrorsArr from 'root/stores/errors/suppressErrorConstants';

export const reduceCreateError = (state, { payload: { type, error } }) => {
  const { errorsToShow = [] } = state;
  return {
    ...state,
    errorsToShow: suppressErrorsArr.includes(type)
      ? errorsToShow
      : [...errorsToShow, type],
    lookup: {
      ...state.lookup,
      [type]: error,
    },
    shown: false,
  };
};
